import type { RankingDistributionMetric } from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/rankingDistribution.types";
import type { EChangeFilterValues } from "app/components/filters-bar/change-filter/ChangeFilter";

export enum EOrganicPaidFilterValues {
    IncludeOrganic,
    IncludePaid,
}

export enum EBrandedNonBrandedValues {
    IncludeBranded,
    IncludeNoneBranded,
}

export interface IWebsiteKeywordsPageFilters {
    IncludeBranded: boolean;
    IncludeNewKeywords: boolean;
    intentsfilter: string;
    IncludeNoneBranded: boolean;
    IncludeOrganic: boolean;
    IncludePaid: boolean;
    IncludeQuestions: boolean;
    IncludeTrendingKeywords: boolean;
    multiIncludeExcludeKeywords: string;
    multiIncludeExcludeWebsites: string;
    filter?: object;
    limits: string;
    family: string;
    source: string;
    webSource: string;
    duration: string;
    country: string;
    positionTrends: string;
    keys: string;
    selectedPhrase: string;
    volumeFromValue: string;
    volumeToValue: string;
    difficultyFromValue: number;
    difficultyToValue: number;
    cpcFromValue: string;
    cpcToValue: string;
    serp: string[];
    ranking: string;
    includeSubDomains?: boolean;
    ExcludeTerms: string;
    IncludeTerms: string;
    ExcludeUrls: string;
    IncludeUrls: string;
    IncludeKeywordGroups: string;
    ExcludeKeywordGroups: string;
    metric: RankingDistributionMetric;
    Change: EChangeFilterValues;
    pageFilter: string;
}
